import { createModalExecutor } from '@organisms/actions/createModalExecutor';
import { IEditRouteMapProps } from './IEditRouteMapProps';
import { EditRouteMapModal } from './EditRouteMapModal';

export const EditRouteMapExecutor = createModalExecutor<IEditRouteMapProps>({
    modal: EditRouteMapModal,
    defaultModalSize: 'l',
    mapProps: ({ action, modalSize, completeHandler }) => ({
        actionKey: action.key,
        activityKey: action.options?.activityKey,
        processKey: action.options?.processKey,
        documentKey: action.options?.documentKey,
        modalSize,
        levelKey: action.options?.levelKey ?? '',
        nextlevelKey: action.options?.nextlevelKey ?? '',
        dueTimeMode: action.options?.dueTimeMode ?? '',
        termType: action.options?.termType ?? '',
        termCount: action.options?.termCount ?? 1,
        periodDate: action.options?.periodDate,
        tasktext: action.options?.tasktext,
        executorId: action.options?.executorId,
        executorDisplayName: action.options?.executorDisplayName,
        abookOptions: action.options?.abookOptions ?? [],
        completeHandler,
    }),
});
